export enum SliceStatus {
  Empty = 'empty',
  Fulfilled = 'fulfilled',
  Error = 'error',
  Updating = 'updating',
}
